import { render, staticRenderFns } from "./RangchaProductDetail.vue?vue&type=template&id=560c8f09&scoped=true"
import script from "./RangchaProductDetail.vue?vue&type=script&lang=js"
export * from "./RangchaProductDetail.vue?vue&type=script&lang=js"
import style0 from "./RangchaProductDetail.vue?vue&type=style&index=0&id=560c8f09&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c8f09",
  null
  
)

export default component.exports